export default __webpack_public_path__ + "static/media/ring-api.7b670c25.png";